import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { AddButton } from '../../../../lib/components/Buttons/AddButton';
import { ButtonsContainer } from '../../../../lib/components/Buttons/ButtonsContainer';
import { LinkButton } from '../../../../lib/components/Buttons/LinkButton';
import { RemoveButton } from '../../../../lib/components/Buttons/RemoveButton';
import { CellStyle } from '../../../../lib/components/DataTable/CellStyle';
import { ColumnFactory } from '../../../../lib/components/DataTable/ColumnFactory';
import { SearchableDataTable } from '../../../../lib/components/SearchableDataTable/SearchableDataTable';
import { useRequestFeedback } from '../../../../lib/hooks';
import { BookEntity } from '../../../../lib/model/Book';
import { useBooksApi } from '../hooks/useBooksApi';

export const BooksDataTable: FC = () => {
	const navigate = useNavigate();
	const { remove } = useBooksApi();

	useRequestFeedback(remove.result, remove.error);

	return (
		<SearchableDataTable
			{...{
				row_data_from_entity: (book: BookEntity) => ({
					...book,
					cover: '',
					book_serie_title: book.book_serie.title,
				}),
				sortable_fields: ['Título'],
				searchable_defaults: {
					sort_field: 'sort1',
					sort_dir: 'desc',
				},
				buttons_on_top: [<AddButton onClick={() => navigate('novo')} />],
				columns: [
					ColumnFactory.Link(
						{
							field: 'title',
							headerName: 'Título',
							resizable: true,
							width: 500,
						},
						(props: { data: { id: string } }) => props.data.id
					),

					{
						field: 'cdd',
						headerName: 'CDD',
						resizable: true,
						width: 200,
					},
					{
						field: 'cdu',
						headerName: 'CDU',
						resizable: true,
						width: 200,
					},
					{
						field: 'book_serie_title',
						headerName: 'Serie',
						resizable: true,
						width: 200,
					},
					{
						col_def: {
							field: 'buttons',
							headerName: '',
							pinned: 'right',
							cellStyle: CellStyle.Centered,
							width: 200,
						},
						renderer: (props: { data: BookEntity }) => (
							<ButtonsContainer class_name='flex center'>
								<LinkButton
									{...{
										name: 'Edições',
										type: 'ghost',
										route: `${props.data.id}/edicoes`,
									}}
								/>

								<RemoveButton
									{...{
										style: { marginLeft: '1rem' },
										on_confirm: () => remove.do_remove(String(props.data.num_id)),
										title: `Deseja remover o livro ${props.data.title}?`,
									}}
								/>
							</ButtonsContainer>
						),
					},
				],
			}}
		/>
	);
};
